<template>
	<div class="flex items-center gap-4 p-4 rounded-sm border border-surface-grey bg-surface-light flex-1">
		<div class="min-w-0 flex-1">
			<p class="h4 text-headings self-stretch line-clamp-2">{{ eventName }}</p>
			<p class="text-headings text-base font-semibold leading-[25px] md:hidden">{{ formattedPrice }}</p>
			<p class="text-headings text-sm font-normal leading-[21px] md:text-text md:text-xs md:leading-5 truncate">{{ eventDate }}</p>
			<p v-if="venueName" class="text-headings text-sm font-normal leading-[21px] md:text-text md:text-xs md:leading-5 truncate">{{ venueName }}</p>
			<button
				type="button"
				class="text-text text-xs font-normal leading-5 underline hover:text-headings mt-1"
				@click="$emit('remove')"
			>
				{{ $t('doorsale.remove_event') }}
			</button>
		</div>
		<img
			:src="photoToUrl(event.photo)"
			:alt="eventName"
			class="flex-shrink-0 w-[100px] h-[56px] rounded-sm object-cover object-center border border-surface-grey md:hidden lg:block"
		/>
	</div>
</template>

<script setup lang="ts">
	import { computed } from 'vue';
	import { useI18n } from 'vue-i18n';

	import { useGeneralStore } from '@/stores/general';
	import type { DoorsaleEvent } from '@/types';
	import { getEventtime } from '@/utils/eventItemUtil';
	import { formatDate } from '@/utils/formatDate';
	import { formatPrice } from '@/utils/formatPrice';
	import { photoToUrl } from '@/utils/photoToUrl';

	defineEmits<{ remove: [] }>();

	const props = defineProps<{
		event: DoorsaleEvent;
	}>();

	const { locale } = useI18n();

	const formattedPrice = computed(() =>
		props.event.price_override_active
			? props.event.price_override_text
			: formatPrice(props.event.price, props.event.currency, locale.value)
	);
	const generalStore = useGeneralStore();

	const venueName = computed(() =>
		generalStore.venues().find(v => v.id === props.event.venue)?.name ?? null
	);

	const eventName = computed(() => props.event.info1 ?? `Begivenhed #${props.event.id}`);

	const eventDate = computed(() => {
		if (props.event.eventtime_override) return props.event.eventtime_override;
		return formatDate(getEventtime(props.event), {
			locale: locale.value,
			timezone: props.event.tz_name || 'Europe/Copenhagen',
		});
	});
</script>
